import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

const copyEntry = async (
  module,
  { originCategoryId, destinationCategoryId, entryId, opts = {} }
) => {
  const { dispatch } = module;
  const api = useApiStore();
  const config = Object.assign(getDefaultOpts(), opts);
  const res = await dispatch("httpRequest", {
    func: api.copyEntry(destinationCategoryId, entryId),
    config,
  });

  if (destinationCategoryId === originCategoryId) {
    // refetch category if we're copying within the same category
    await dispatch("fetchCategory", { id: originCategoryId, opts });
  }

  return res;
};

export { copyEntry };
